import React, { useState } from 'react';
import { Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { notificationService } from '../services/api';

const AdminBroadcastPanel: React.FC = () => {
  const [titlePt, setTitlePt] = useState('');
  const [titleEn, setTitleEn] = useState('');
  const [bodyPt, setBodyPt] = useState('');
  const [bodyEn, setBodyEn] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [result, setResult] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setResult(null);
    if (!titlePt.trim() || !titleEn.trim()) {
      setError('Title in Portuguese and English are required.');
      return;
    }
    setSubmitting(true);
    try {
      const res = await notificationService.adminBroadcast({
        titlePt: titlePt.trim(),
        titleEn: titleEn.trim(),
        bodyPt: bodyPt.trim() || null,
        bodyEn: bodyEn.trim() || null,
      });
      setResult(`Sent: ${res.notificationsCreated} notifications created for all users.`);
      setBodyPt('');
      setBodyEn('');
    } catch (err: unknown) {
      const msg =
        err && typeof err === 'object' && 'response' in err
          ? (err as { response?: { data?: { message?: string } } }).response?.data?.message
          : null;
      setError(msg ?? 'Broadcast failed.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-tab-content">
      <h3>Global notification broadcast</h3>
      <p className="text-muted">
        Sends an in-app notification to every user. Both Portuguese (BR) and English titles are required.
      </p>
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          {error}
        </Alert>
      )}
      {result && (
        <Alert variant="success" dismissible onClose={() => setResult(null)}>
          {result}
        </Alert>
      )}
      <Form onSubmit={(e) => void handleSubmit(e)}>
        <Row className="g-3">
          <Col md={6}>
            <h5 className="h6 text-muted">Portuguese (BR)</h5>
            <Form.Group className="mb-2">
              <Form.Label>Title *</Form.Label>
              <Form.Control
                value={titlePt}
                onChange={(e) => setTitlePt(e.target.value)}
                maxLength={200}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Body (optional)</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={bodyPt}
                onChange={(e) => setBodyPt(e.target.value)}
                maxLength={4000}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <h5 className="h6 text-muted">English</h5>
            <Form.Group className="mb-2">
              <Form.Label>Title *</Form.Label>
              <Form.Control
                value={titleEn}
                onChange={(e) => setTitleEn(e.target.value)}
                maxLength={200}
                required
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Body (optional)</Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                value={bodyEn}
                onChange={(e) => setBodyEn(e.target.value)}
                maxLength={4000}
              />
            </Form.Group>
          </Col>
        </Row>
        <Button type="submit" variant="primary" className="mt-3" disabled={submitting}>
          {submitting ? 'Sending…' : 'Send to all eligible users'}
        </Button>
      </Form>
    </div>
  );
};

export default AdminBroadcastPanel;
